<!-- footer start-->
<div class="container-fluid">
  <div class="row">
    <div class="col-md-12 footer-copyright text-center">
      <p class="mb-0">&copy; Strongside 2023 All Rights Reserved.</p>
    </div>
  </div>
</div>